// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import ElementUI from 'element-ui'
import './styles/element-custom.scss'
import locale from 'element-ui/lib/locale/lang/en'
import router from './router'
// import vueConfig from 'vue-config'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
import LoadScript from 'vue-plugin-load-script'
import store from './store/index.js'

Vue.config.productionTip = false

Vue.use(ElementUI, { locale })
Vue.use(Vuex)
// Vue.use(vueConfig, configs)
Vue.use(LoadScript)

Vue.prototype.$ngl = {}

const requireComponent = require.context(
  // The relative path of the components folder
  './components/base',
  // Whether or not to look in subfolders
  false,
  // The regular expression used to match base component filenames
  /[A-Z]\w+\.(vue|js)$/
)

requireComponent.keys().forEach(fileName => {
  // Get component config
  const componentConfig = requireComponent(fileName)

  // Get PascalCase name of component
  const componentName = upperFirst(
    camelCase(
      // Strip the leading `./` and extension from the filename
      fileName.replace(/^\.\/(.*)\.\w+$/, '$1')
    )
  )

  // Register component globally
  Vue.component(
    componentName,
    // Look for the component options on `.default`, which will
    // exist if the component was exported with `export default`,
    // otherwise fall back to module's root.
    componentConfig.default || componentConfig
  )
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
  render: h => h(App)
})
